var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px" },
          on: {
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              ) {
                return null
              }
              _vm.groupDialog = false
            }
          },
          model: {
            value: _vm.groupDialog,
            callback: function($$v) {
              _vm.groupDialog = $$v
            },
            expression: "groupDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v("\n Group Payment\n      ")]),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.payTogether($event)
                    }
                  },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-data-table",
                        {
                          staticClass: "no-footer-table",
                          attrs: {
                            headers: _vm.groupHeaders,
                            items: _vm.allGroupItems,
                            "item-key": "id"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item.price",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _c("span", [
                                    _vm._v("$" + _vm._s(item.price) + " ")
                                  ])
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("template", { slot: "body.append" }, [
                            _c("tr", { staticClass: "pink--text" }, [
                              _c("th", { staticClass: "title" }, [
                                _vm._v("Total")
                              ]),
                              _vm._v(" "),
                              _c("th", { staticClass: "title" }, [
                                _vm._v(
                                  "$" +
                                    _vm._s(_vm.sum(_vm.allGroupItems, "price"))
                                )
                              ])
                            ])
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          on: {
                            click: function($event) {
                              _vm.groupDialog = false
                            }
                          }
                        },
                        [_vm._v("Close")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            loading: _vm.groupLoading,
                            color: "green",
                            type: "Submit"
                          }
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-playlist-check")
                          ]),
                          _vm._v("Paid ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }